import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import SideBarComponents from '../../components/SideBar/SideBarComponents'
import StatisticsList from '../../components/DashBoard/Statistics/StatisticsList';
import Meta from '../../components/Helmet/Meta';
import './dashboard.css'

const DashboardScreen = () => {
    return (
        <div className="main"  fluid >
            <Meta
                title=" | Admin Dashboard"
            />
            <Container fluid>
                <Row>
                    <Col md={3}>
                    </Col>
                    <Col md={9}>
                        <h4 > Statistiques générales </h4>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <SideBarComponents />
                    </Col>
                    <Col md={9}>
                        <StatisticsList />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default DashboardScreen
